import './App.css';
import { Container, CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import LandingPage from './Components/LandingPage';
import { Route, Routes } from 'react-router-dom';
import Nav from './Components/Nav';
import Admin from './Components/Admin';
import SignUpForm from './Components/SignUpForm';
import { useEffect, useState } from 'react';
import { auth, getUser } from './firebase';
import { useDispatch, useSelector } from 'react-redux';
import {  setCurrentUser } from './applicationSlice';
import SignIn from './Components/SignIn';
import AlgoAddict420 from './Components/AlgoAddict420';
import { About } from './Components/About';
import Blog from './Components/Blog';
import ManagePosts from './Components/ManageBlogPosts';
import VariableBlogEditor from './Components/VariableBlogEditor';
import BlogPost from './Components/BlogPost';
import { ToastContainer } from 'react-toastify';
import VariablePageEditor from './Components/VariablePageEditor';

const palette = {
  forest: '#3A5A40',
  moss: '#6B8F71',
  mist: '#F5F7F2',
  clay: '#DCCCAA',
  accent: '#9FBF9B',
  deep: '#1F2A1C',
};

const theme = createTheme({
  palette: {
    primary: {
      main: palette.forest,
      contrastText: '#F7F9F4',
    },
    secondary: {
      main: palette.accent,
      contrastText: '#1F2A1C',
    },
    background: {
      default: palette.mist,
      paper: '#FFFFFF',
    },
    text: {
      primary: palette.deep,
      secondary: '#4B5A4D',
    },
  },
  shape: {
    borderRadius: 14,
  },
  typography: {
    fontFamily: '"Manrope", "Segoe UI", sans-serif',
    h1: {
      fontFamily: '"Playfair Display", "Georgia", serif',
      letterSpacing: '0.01em',
      fontWeight: 700,
    },
    h2: {
      fontFamily: '"Playfair Display", "Georgia", serif',
      letterSpacing: '0.01em',
      fontWeight: 600,
    },
    h3: {
      fontFamily: '"Playfair Display", "Georgia", serif',
      fontWeight: 600,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.7,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
      letterSpacing: '0.02em',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundImage:
            'radial-gradient(circle at 20% 20%, rgba(159,191,155,0.28), transparent 40%), radial-gradient(circle at 80% 0%, rgba(220,204,170,0.25), transparent 45%), radial-gradient(circle at 70% 80%, rgba(107,143,113,0.18), transparent 45%)',
          backgroundColor: palette.mist,
          color: palette.deep,
          minHeight: '100vh',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 18,
          border: '1px solid rgba(58,90,64,0.08)',
          boxShadow: '0 10px 40px rgba(31,42,28,0.08)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          paddingInline: '18px',
          paddingBlock: '10px',
          boxShadow: '0 12px 30px rgba(58,90,64,0.18)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 12px 40px rgba(31,42,28,0.12)',
        },
      },
    },
  },
});
function App() {
  const application = useSelector((state)=>state.application);
  const wallet = useSelector((state)=>state.wallet);
  const dispatch = useDispatch();
  const [user, setUser] = useState({});

  useEffect(()=>{
    setUser(application.currentUser??{});
    return ()=>{}
  },[application.currentUser])
  
    useEffect(() => {
     // getNFTs().then((nfts)=>dispatch(setCollections(nfts)));
     
      auth.onAuthStateChanged((auth)=> {
        console.log("Auth state changed",auth);
        if (auth) {
          getUser(auth.uid).then((u=>{
            console.log('user',u);
            dispatch(setCurrentUser(u));
            setUser(u);
            
          }));
        }else{
          dispatch(setCurrentUser({}));
          setUser({});
          
        }
      });
    }, []);





  return (
    <ThemeProvider theme={theme}>
    <CssBaseline />
    <Nav/>
     <Container maxWidth="lg" sx={{py: { xs: 2, md: 4 }}}>
    <Routes>
   
    <Route path="/" exact element={<LandingPage/>} />
    <Route path="/about" exact element={<About/>} />
    <Route path="/blog" exact element={<Blog/>} />
    <Route path="/post/:blogId" element={<BlogPost />} /> {/* ✅ Accepts blogId */}
    <Route path="/edit-page/:id" element={<VariablePageEditor />} />
    <Route path="/sign-up"  element={<SignUpForm/>} />
    <Route path="/sign-in"  element={<SignIn/>} />
    {user.role==='admin'?<Route path="/admin"  element={<Admin/>} />:''}
    {user.role==='admin'?<Route path="/manage-posts"  element={<ManagePosts/>} />:''}
     {user.role === 'admin' && (
  <Route path="/new-post" element={<VariableBlogEditor />} />
)}
    {user.role === 'admin' && (
  <Route path="/edit-post/:id" element={<VariableBlogEditor />} />
)}








    </Routes>
    <AlgoAddict420/>
    <ToastContainer />
    </Container>
    </ThemeProvider>
  );
}

export default App;
